interface ApiErrorOptions extends ErrorOptions {
  status?: number
}

export default class ApiError extends Error {
  status?: number

  constructor(message: string, options?: ApiErrorOptions) {
    // @ts-ignore
    super(message, { cause: options?.cause })
    this.status = options?.status
  }
}
